window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views['select/document'] = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el.find('[data-page]');

        this.link = editor.link;
        this.structure = this.$el.data('structure');
        this.nps = this.$el.data('nps') || '';
        this.$selection = null;
        this.anchors = this.$el.data('anchors') !== 'disallow';
        this.options = opts;

        var $dl = this.$('#downloadSelect');
        XMLSelect($dl, 'load', {
            url: opts.path + 'documentDownloadTypes.xml',
            data: {structure: this.structure,  nps: this.nps}
        }).then(function () {
            var nbOptions = $dl.find('option').length;
            self.$('#downloadType').toggle(nbOptions>1);
        });
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this;

        self.$el.on('change.npseditorlinksSelectDocument', '[data-action="choose-structure"]', function() {
            var structure = $(this).val();
            self.link.setProperty('structure', structure);
            self.editor.load('select/document', {structure: structure});
        });
        self.$el.on('change.npseditorlinksSelectDocument', '[data-action="choose-nps"]', function() {
            var nps = $(this).val();
            self.link.setProperty('nps', nps)
            self.editor.load('select/document', {structure: structure, nps: nps});
        });
        self.$el.on('click.npseditorlinksSelectDocument', '#treeContainer .item', function() {
            var $item = $(this),
                $anchors = self.$('#targetAnchor'),
                $downsel = self.$('#downloadSelect').find(':selected')
            ;
            if (self.$selection) {
                self.$selection.removeClass('selected');
            }
            $item.addClass('selected');
            self.$selection = $item;

            $anchors.hide();
            if (self.anchors && self.$selection && $downsel.length) {
                if (($downsel.data('info').anchor) && ($downsel.data('info').anchor==='yes')) {
                    $anchors.show();

                    XMLSelect(self.$('#anchorSelect'), 'load', {
                        url: self.options.path + 'documentAnchors.xml',
                        data: {documentId: $item.attr('documentId')}
                    });
                }
            }

            self.editor.enableNext('select/document');
        });

        if (self.link.getProperty('documentId')) {
            this.$('.item[documentId="'+self.link.getProperty('documentId')+'"]').click();
        }

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksSelectDocument');
        return this;
    };

    view.prototype.commit = function () {
        var self = this,
            $downsel = self.$('#downloadSelect').find(':selected'),
            $anchorsel = self.$('#anchorSelect').find(':selected'),
            info = $downsel.data('info');

        if (!self.$selection) return self;
        if (!$downsel.length) return self;

        var linker = info.linker,
            documentId = self.$selection.attr('documentId'),
            anchorId = $anchorsel.val() || '';

        var aParams = [
            'documentId='+documentId
        ];

        if (linker.indexOf('?')!=-1) {
            var strMoreParams = linker.substr(linker.indexOf('?')+1);
            linker = linker.substr(0, linker.indexOf('?'));

            var mParams = strMoreParams.split('&');
            for (var i=0, l = mParams.length; i<l; i++) {
                aParams.push(mParams[i]);
            }
        }

        var url= linker+'?'+aParams.join('&');
        if (anchorId) {
             url+= "#"+anchorId;
        }

        self.link.setProperties({
            content: 'p',
            link: url,
            structure: this.structure,
            documentId: documentId,
            anchorId: anchorId,
            displayMode: $downsel.val()
        });

        return this;
    };
    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);